export default "__VITE_ASSET__DD$LdoiB__"